import React from 'react'
import Page from 'component/page-container'
import { nl2br } from 'helpers'

import './style.css'

/* global API */

const AchivmentRoute = () => {
    const [ achivmentList, setAchivmentList ] = React.useState([])

    React.useEffect(() => {
        API.instance().achivment.getList().then(setAchivmentList)
    }, [])

    return (
        <Page className="news-list-page" h1="Ачивки">
            <div className="page__inner">
                {!!achivmentList.length ? (
                    <div className="achivment">
                        {achivmentList.map(achivment => (
                            <div key={achivment.id} className="achivment__item">
                                <div className="achivment__user">Достижение {achivment.toUser.name} {achivment.toUser.surname}</div>
                                <div className="achivment__text" dangerouslySetInnerHTML={{__html: nl2br(achivment.text)}} />
                                <div className="achivment__from-user">выдал: {achivment.fromUser.name} {achivment.fromUser.surname} в <a href={achivment.process.telegramLink}>{achivment.process.title}</a></div>
                            </div>
                        ))}
                    </div>
                ) : 'Пустенько пока'}
            </div>
        </Page>
    )
}

export default AchivmentRoute
